import React from 'react'

const InputButton = props => (
  <input
    className={props.addClass ? props.addClass : ''}
    type={props.inputType}
    value={props.text}
  />
)

export default InputButton
